import styled from 'styled-components'

export const Wrapper = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`
